import React from 'react';
import styled from 'styled-components';
import { useThemeColor } from '../context/ThemeContext';

const StyledView = styled.div`
  background-color: ${props => props.backgroundColor};
  ${props => props.customStyles}
`;

export const ThemedView = ({
  children,
  lightColor,
  darkColor,
  style,
  className,
  ...otherProps
}) => {
  const backgroundColor = useThemeColor(
    { light: lightColor, dark: darkColor },
    'background'
  );

  return (
    <StyledView
      backgroundColor={backgroundColor}
      customStyles={style}
      className={className}
      {...otherProps}
    >
      {children}
    </StyledView>
  );
};